import * as ActionTypes from "../constants/actionTypes"

function init(): Record<string, any> {
	return {}
}

export const staticDataReducer = (state: Record<string, any> = init(), action: any): Record<string, any> => {
	switch (action.type) {
		case ActionTypes.UPDATE_STATIC_DATA:
			return {
				...state,
				...action.payload,
			}
		case ActionTypes.UPDATE_PLAN_STATIC_DATA:
			return {
				...state,
				...action.payload,
			}
		default:
			return state
	}
}
